import type { GoalsScorelineData } from '../../../types';

interface ScorelineChartPanelProps {
  scorelines: GoalsScorelineData[];
}

export function ScorelineChartPanel({ scorelines }: ScorelineChartPanelProps) {
  if (!scorelines.length) {
    return (
      <div className="goals-panel goals-scoreline-panel">
        <h4>Most Likely Scorelines</h4>
        <p className="goals-empty-text">No scoreline data available</p>
      </div>
    );
  }

  // Get max probability for scaling
  const maxProb = Math.max(...scorelines.map((s) => s.probability));

  return (
    <div className="goals-panel goals-scoreline-panel">
      <h4>Most Likely Scorelines</h4>
      <div className="goals-scoreline-chart">
        {scorelines.slice(0, 6).map((scoreline, idx) => {
          const widthPct = (scoreline.probability / maxProb) * 100;
          return (
            <div key={idx} className="goals-scoreline-bar-item">
              <div className="goals-scoreline-label">
                <span className="goals-scoreline-score">{scoreline.scoreline}</span>
                <span className="goals-scoreline-prob">{(scoreline.probability * 100).toFixed(1)}%</span>
              </div>
              <div className="goals-scoreline-bar-track">
                <div
                  className={`goals-scoreline-bar-fill ${scoreline.btts ? 'goals-btts-yes' : 'goals-btts-no'}`}
                  style={{ width: `${widthPct}%` }}
                />
              </div>
              {scoreline.btts && (
                <span className="goals-scoreline-btts-badge">BTTS</span>
              )}
            </div>
          );
        })}
      </div>
      <div className="goals-scoreline-legend">
        <span className="goals-legend-item goals-legend-btts">
          <span className="goals-legend-color goals-btts-yes" />
          BTTS Yes
        </span>
        <span className="goals-legend-item goals-legend-no-btts">
          <span className="goals-legend-color goals-btts-no" />
          BTTS No
        </span>
      </div>
    </div>
  );
}

export default ScorelineChartPanel;
